import {Action} from "redux";

import {
    GetEntryProjectsByCustomerRequest,
} from "../request/entry_request";
import {
    GetEntryProjectsByCustomerResponse,
} from "../response/entry_response";

export enum CustomerEntriesActionType {
    REQUEST_GET_ENTRY_PROJECTS = "CUSTOMER_ENTRY_REQUEST_GET_ENTRY_PROJECTS",
    CALLBACK_GET_ENTRY_PROJECTS = "CUSTOMER_ENTRY_CALLBACK_GET_ENTRY_PROJECTS",
}

export interface IRequestGetEntryProjectsAction extends Action {
    type: CustomerEntriesActionType.REQUEST_GET_ENTRY_PROJECTS;
    item: GetEntryProjectsByCustomerRequest;
}

export interface ICallbackGetEntryProjectsAction extends Action {
    type: CustomerEntriesActionType.CALLBACK_GET_ENTRY_PROJECTS;
    isSuccess: boolean;
    item?: GetEntryProjectsByCustomerResponse;
}

export type CustomerEntriesAction =
    IRequestGetEntryProjectsAction |
    ICallbackGetEntryProjectsAction
    ;

export interface ICustomerEntriesActionCreator {
    requestGetEntryProjectsAction(item: GetEntryProjectsByCustomerRequest): IRequestGetEntryProjectsAction;

    callbackGetEntryProjectsAction(
        isSuccess: boolean,
        item?: GetEntryProjectsByCustomerResponse,
    ): ICallbackGetEntryProjectsAction;

}

class ActionCreator implements ICustomerEntriesActionCreator {
    public requestGetEntryProjectsAction = (item: GetEntryProjectsByCustomerRequest): IRequestGetEntryProjectsAction => {
        return {
            type: CustomerEntriesActionType.REQUEST_GET_ENTRY_PROJECTS,
            item,
        };
    };

    public callbackGetEntryProjectsAction = (
        isSuccess: boolean,
        item?: GetEntryProjectsByCustomerResponse,
    ): ICallbackGetEntryProjectsAction => {
        return {
            type: CustomerEntriesActionType.CALLBACK_GET_ENTRY_PROJECTS,
            isSuccess,
            item,
        };
    };

}

export const createCustomerEntriesActionCreator = (): ICustomerEntriesActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_entries_action.ts